import { NgModule } from '@angular/core';
import { AmdButtonModule } from './button/button.module';
import { AmdInputModule } from './input/input.module';
import { AmdInputContainerModule } from './input-container/input-container.module';
import { AmdOptionModule } from './option/option.module';
import { AmdSelectModule } from './select/select.module';
var /** @type {?} */ modules = [
    AmdButtonModule,
    AmdInputModule,
    AmdInputContainerModule,
    AmdOptionModule,
    AmdSelectModule
];
var AmdFormModule = /** @class */ (function () {
    function AmdFormModule() {
    }
    AmdFormModule.decorators = [
        { type: NgModule, args: [{
                    imports: modules,
                    exports: modules
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdFormModule.ctorParameters = function () { return []; };
    return AmdFormModule;
}());
export { AmdFormModule };
function AmdFormModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdFormModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdFormModule.ctorParameters;
}
//# sourceMappingURL=form.module.js.map
//# sourceMappingURL=form.module.js.map
